// extracted by mini-css-extract-plugin
export default {"table_row_center":"row-version_table_row_center__xEhOP"};